import {Box} from '@mui/material';
import {FC, ReactNode, useLayoutEffect, useState} from 'react';
import './CellWrapper.scss';
import ArrTooltip from '../../../arr-tooltip/ArrTooltip';
import {GridRenderCellParams} from '@mui/x-data-grid-pro';

type CellWrapperProps = {
  toolTipContent?: ReactNode;
  hideTooltip?: boolean;
  className?: string;
  dataTestId?: string;
  children?: ReactNode;
  tabIndex?: number;
  cellParams?: GridRenderCellParams;
  alwaysShowToolTip?: boolean;
};

const CellWrapper: FC<CellWrapperProps> = ({
  toolTipContent = '',
  hideTooltip,
  className = '',
  dataTestId = '',
  children,
  tabIndex,
  cellParams,
  alwaysShowToolTip = false,
}) => {
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    if (
      hideTooltip ||
      typeof toolTipContent !== 'string' ||
      !toolTipContent ||
      !cellParams
    ) {
      setIsTruncated(false);
      return;
    }

    const columnWidth = cellParams.colDef?.computedWidth;
    if (!columnWidth) {
      setIsTruncated(false);
      return;
    }

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.font = '0.875rem Inter';

    const textWidth = ctx.measureText(toolTipContent).width;

    const PADDING_BUFFER = 32;

    setIsTruncated(textWidth > columnWidth - PADDING_BUFFER);
  }, [toolTipContent, cellParams, hideTooltip]);

  const shouldShowTooltip = alwaysShowToolTip
    ? alwaysShowToolTip
    : !hideTooltip && toolTipContent !== '' && isTruncated;

  const content = <Box className="wrapper-content">{children}</Box>;

  return (
    <Box
      className={`arr-data-grid-pro-cell-Wrapper ${className}`}
      data-testid={dataTestId}
      tabIndex={-1}
    >
      {shouldShowTooltip ? (
        <ArrTooltip
          content={toolTipContent}
          hideInfoIconOnEmptyChildren
          tabIndex={tabIndex}
          labelId={`tooltip-cell-wrapper-${dataTestId}`}
        >
          {content}
        </ArrTooltip>
      ) : (
        content
      )}
    </Box>
  );
};

export default CellWrapper;
